export const SET_LOADING = '[🛡️] set loading';
export const SET_USER = '[🛡️] set user info';
export const SET_USER_SESSION = '[🛡️] set user sesion authenticated';
export const REMOVE_USER = '[🛡️] remove user';
export const CLEAR_USER_SESSION = '[🛡️] clear user session';
export const HANDLE_SIGN_IN = '[🛡️] handle sign in';
export const HANDLE_SIGN_IN_ERROR = '[🛡️] handle sign in error';
export const SET_USER_COMPANY = '[🛡️] set user company';
export const SET_USER_METADATA = '[🛡️] set user metadata';
export const SET_USER_CLINIC = '[🛡️] set user clinic';
